import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage37 from "../../../../assets/PDFViewerImages/PDFViewerImage37.jpg";
import PDFViewerImage38 from "../../../../assets/PDFViewerImages/PDFViewerImage38.jpg";
import PDFViewerImage39 from "../../../../assets/PDFViewerImages/PDFViewerImage39.jpg";
import PDFViewerImage40 from "../../../../assets/PDFViewerImages/PDFViewerImage40.jpg";
import PDFViewerImage41 from "../../../../assets/PDFViewerImages/PDFViewerImage41.jpg";
import PDFViewerImage42 from "../../../../assets/PDFViewerImages/PDFViewerImage42.jpg";
import PDFViewerImage43 from "../../../../assets/PDFViewerImages/PDFViewerImage43.jpg";
import PDFViewerImage44 from "../../../../assets/PDFViewerImages/PDFViewerImage44.jpg";
import PDFViewerImage45 from "../../../../assets/PDFViewerImages/PDFViewerImage45.jpg";
import PDFViewerImage46 from "../../../../assets/PDFViewerImages/PDFViewerImage46.jpg";

const Chapter20 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);


    return (
        <>
                 {/* Chapter 20 */}
                <section id="section20" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter20Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter20Paragraph1}

                    </p>
                    <div className="image-box">
                        <img src={PDFViewerImage37} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter20Paragraph2}


                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter20Paragraph3}


                    </p>

                    <h3 className="drivers-handbook-subheading"> {language.chapter20Subheading1}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter20List11}</li>
                        <li>{language.chapter20List12}</li>
                    </ul>

                    <h3 className="drivers-handbook-subheading">{language.chapter20Subheading2}</h3>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter20Paragraph4}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter20Paragraph5}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter20Paragraph6}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage38} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph7}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage39} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph8}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage40} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph9}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage41} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph10}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage42} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter20Subheading3}</h3>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph11}
                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph12}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage43} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph13}
                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph14}

                    </p>
                    <div className="image-box">
                        <img src={PDFViewerImage44} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph15}

                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter20Paragraph16}

                    </p>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter20List2}
                        </li>
                    </ul>

                    <div className="image-box">
                        <img src={PDFViewerImage45} alt="Traffic Rules"/>
                    </div>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter20List3}
                        </li>
                    </ul>

                    <div className="image-box">
                        <img src={PDFViewerImage46} alt="Traffic Rules"/>
                    </div>


                </section>

        </>
    )

}

export default Chapter20;
